var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Filters-wrapper"},[_c(_vm.pageComponentType,{tag:"component",attrs:{"params":_vm.params,"query":_vm.query,"navData":_vm.navData,"configuration":_vm.config},on:{"setQuery":_vm.updateQuery}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }